import { useCallback } from "react"
import { useFetcher } from "react-router"

import {
  SharedEvidenceThemesTab,
  type EvidenceThemesFetcherData,
  type EvidenceThemesFormValues,
} from "../shared/SharedEvidenceThemesTab"
import type { EnhancedConfigData, EvidenceThemesConfig } from "./brand-lenses-configuration"

export function EvidenceThemesTab({ data, config }: { data: EnhancedConfigData; config: EvidenceThemesConfig }) {
  const fetcher = useFetcher<EvidenceThemesFetcherData>()
  const pendingAction = (fetcher.json as { action?: "SAVE_SECTION" | "REMOVE_SECTION" } | undefined)?.action ?? null

  const handleSave = useCallback(
    (values: EvidenceThemesFormValues) => {
      fetcher.submit(
        {
          action: "SAVE_SECTION",
          organisation: data.loadedOrganisation,
          project: data.loadedProject,
          jsonPath: "$.evidenceThemes",
          value: {
            ...values,
            filters: config.filters ?? [],
          },
          concurrency: data.existingConfig?.concurrency ?? "",
        },
        { method: "post", encType: "application/json" },
      )
    },
    [fetcher, data, config.filters],
  )

  const handleRemove = useCallback(() => {
    fetcher.submit(
      {
        action: "REMOVE_SECTION",
        organisation: data.loadedOrganisation,
        project: data.loadedProject,
        jsonPath: "$.evidenceThemes",
        concurrency: data.existingConfig?.concurrency ?? "",
      },
      { method: "post", encType: "application/json" },
    )
  }, [fetcher, data])

  return (
    <SharedEvidenceThemesTab
      config={config}
      data={data}
      fetcher={fetcher}
      pendingAction={pendingAction}
      onSave={handleSave}
      onRemove={handleRemove}
    />
  )
}
